import { Html5QrcodeScanner } from 'html5-qrcode';
import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';
import { useNavigate } from 'react-router-dom';

const HospitalQr = () => {

    const [holderAndMembers, setHolderAndMembers] = useState([]);

    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();

    useEffect(() => {

        const scanner = new Html5QrcodeScanner('qr-reader', {
            qrbox: 150,
            fps: 10,
        }, undefined);

        const success = (result) => {
            scanner.clear();
            fetchHolderAndMembers(result);
        }

        scanner.render(success, error => {
            console.warn(error);
        });

        return () => {
            if (scanner) scanner.clear();
        }

        // eslint-disable-next-line
    }, []);

    const handleAdmitPatient = async (patientId) => {
        try {
            const response = await axiosPrivate.post("/hospital/addPatient/" + patientId);

            notify('success', response.data?.success);
            setHolderAndMembers([]);
            navigate('/');
        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    const fetchHolderAndMembers = async (holderId) => {
        try {
            const response = await axiosPrivate.get("/hospital/getHolderMembers/" + holderId);

            setHolderAndMembers([
                {
                    _id: response.data?._id,
                    name: response.data?.name,
                    gender: response.data?.gender,
                    age: response.data?.age,
                    mobile: response.data?.mobile
                }, ...response.data?.members]);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
            navigate('/');
        }
    }

    return (
        <div className="container" style={{ margin: '10px' }}>

            {holderAndMembers.length === 0 && <div id='qr-reader'></div>}

            {
                holderAndMembers?.length !== 0 &&
                <section className="user-list">
                    <div className="list-header">
                        <span>Name</span>
                        <span>Gender</span>
                        <span>Age</span>
                        <span>Mobile</span>
                        <span>Action</span>
                    </div>

                    {
                        holderAndMembers.map((patient) => (
                            <div className="list-row" key={patient?._id}>
                                <span className='truncate' title={patient?.name} data-label="Name">{patient?.name}</span>
                                <span className='truncate' title={patient?.gender} data-label="Gender">{patient?.gender}</span>
                                <span className='truncate' title={patient?.age} data-label="Age">{patient?.age}</span>
                                <span className='truncate' title={patient?.mobile} data-label="Action">{patient?.mobile}</span>
                                <span><button className="approve-btn" onClick={() => handleAdmitPatient(patient?._id)}>Admit</button></span>
                            </div>
                        ))
                    }

                </section>
            }
        </div>
    )
}

export default HospitalQr
